var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"d-flex align-center justify-center pl-4 pr-4 pb-6 pt-6"},[_c('div',{staticClass:"bullets d-flex justify-space-between align-center"},[_c('div',{staticClass:"line-connector"}),_vm._l((_vm.steps),function(i){return _c('div',{key:i,staticClass:"bullet d-flex justify-center align-center",class:{
        active: i === _vm.stepFlag,
        disable: i >= _vm.stepFlag,
      }},[_vm._v(" "+_vm._s(i)+" ")])})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }